import { render, staticRenderFns } from "./ImagenPanoramica.vue?vue&type=template&id=9ffcbf0a"
import script from "./ImagenPanoramica.vue?vue&type=script&lang=js"
export * from "./ImagenPanoramica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports